import { dateBackendToUI } from 'modules/core/lib/dates'
import centsToDecimal from 'modules/core/lib/formatCents'

import { FieldTypes } from 'modules/custom_resources/store/collections/customFields/fields'
import type CustomFieldValue from 'modules/custom_resources/store/models/customFields/Value'

export const formatCustomFieldValue = (customFieldValue?: CustomFieldValue) => {
  if (!customFieldValue) return undefined
  switch (customFieldValue.attributes.type) {
    case FieldTypes.cents:
      return centsToDecimal(customFieldValue.attributes.value)
    case FieldTypes.date:
      return dateBackendToUI(customFieldValue.attributes.value)
    default:
      return customFieldValue.attributes.value
  }
}
